module.exports = {
  'listVpcs': '/api/cps/listVpcs', //获取当前私有网络列表
};



// WEBPACK FOOTER //
// ./src/api/privateNetwork/list/config.js